import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["color", "text", "preview"]

  connect() {
    this.apply()
  }

  syncFromColor() {
    this.textTarget.value = this.colorTarget.value.toUpperCase()
    this.apply()
  }

  syncFromText() {
    const value = this.textTarget.value.trim()
    if (/^#[0-9A-Fa-f]{6}$/.test(value)) {
      this.colorTarget.value = value
      this.apply()
    }
  }

  apply() {
    if (!this.hasPreviewTarget) return
    this.previewTarget.style.setProperty("--preview-color", this.colorTarget.value)
  }
}
